exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-box[data-v-4f8c92d8]{padding:20px;padding-bottom:50px}\n", ""]);

// exports
